<script lang="ts">
	import verify1 from '$lib/assets/about/verify-climate-action-1.webp';
	import verify2 from '$lib/assets/about/verify-climate-action-2.webp';
	import verify3 from '$lib/assets/about/verify-climate-action-3.webp';

	const VerificationSteps = [
		{
			img: verify1,
			text: 'Fans select an activity and upload a photo to score a green goal.'
		},
		{
			img: verify2,
			text: "Planet League's VAR team check the photo to verify action taken is legit."
		},
		{
			img: verify3,
			text: 'Impact is translated into easy to understand language.'
		}
	];
</script>

<div class="py-12 md:py-24 space-y-16">
	<div class="font-title text-center text-2xl md:text-4xl leading-tight max-w-4xl mx-auto">
		We help verify social and climate action, giving our partners a clear and credible way to
		demonstrate impact.
	</div>

	<div class="grid grid-cols-1 md:grid-cols-3 gap-12">
		{#each VerificationSteps as step (step.img)}
			<div class="flex flex-col items-center text-center space-y-6">
				<img src={step.img} alt="Verification step" class="h-48 md:h-64 object-contain" />
				<p class="text-sm text-slate-600 px-4 leading-relaxed">{step.text}</p>
			</div>
		{/each}
	</div>
</div>
